import { type FC, type PropsWithChildren } from 'react';
import { Typography, type TypographyProps } from '@mui/material';

export type MessageProps = PropsWithChildren<TypographyProps>;

export const Message: FC<MessageProps> = ({ children, ...props }) => (
  <Typography variant="body1" color="text.secondary" {...props}>
    {children}
  </Typography>
);
